import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getInvoiceFile } from '../../../services/invoices';

export const ThunkGetInvoiceFile = createAsyncThunk<any, number>(
  `${storeResources.INVOICES}/getInvoices`,
  (invoiceId) => getInvoiceFile(invoiceId).then(res => res.data),
);
